import Auth from '@aws-amplify/auth';
import { JS } from '@aws-amplify/core';
import { Alert, Button, Input, LinkButton, Spinner } from '@salecycle/ui-component-library';
import React, { FC } from 'react';
import LoginFormHeader from './loginFormHeader';
import { AlertContainer, SubmitContainer, SubmitButtonContainer } from './styles';

export interface IState {
  code: string;
  errorMessage: string;
}

interface Props {
  changeState: (state: any, data?: any, emailAddress?: string) => void;
  authData: any;
}

export const MFAToken: FC<Props> = props => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [code, setCode] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleCodeChange = (event: any) => {
    setCode(event);
  };

  const handleBackToSignIn = () => {
    props.changeState('signIn');
  };

  const confirmCode = (event: any) => {
    if (event) {
      event.preventDefault();
    }
    setIsLoading(true);
    const user = props.authData;
    const mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null;
    if (!Auth || typeof Auth.confirmSignIn !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.confirmSignIn(user, code, mfaType)
      .then(() => {
        checkContact(user);
      })
      .catch(err => setErrorMessage(err.message));

    setIsLoading(false);
  };

  const checkContact = (user: any) => {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.verifiedContact(user).then(data => {
      if (!JS.isEmpty(data.verified)) {
        props.changeState('signedIn', user);
      } else {
        const newUser = Object.assign(user, data);
        props.changeState('verifyContact', newUser);
      }
    });
  };

  return (
    <>
      <LoginFormHeader
        heading="Two-Factor Authentication"
        description1="You have two-factor authentication associated with your account. Use your chosen
                auth app to fetch your code."
      />

      {errorMessage && (
        <AlertContainer>
          <Alert heading={errorMessage} variation="error" />
        </AlertContainer>
      )}

      <form onSubmit={confirmCode}>
        <Input
          ariaLabel="Verification Code"
          label="Verification Code"
          inputId="VerificationCodeInput"
          placeholder="Enter your verification code"
          required={true}
          onChange={handleCodeChange}
          key="Verification Code"
        />

        <SubmitContainer>
          <SubmitButtonContainer>
            <Button type="submit" onClick={confirmCode} variation="primary" disabled={isLoading}>
              Confirm Code
            </Button>

            {isLoading && <Spinner />}
          </SubmitButtonContainer>
        </SubmitContainer>

        <SubmitContainer>
          <LinkButton onClick={handleBackToSignIn}>Back to Sign In</LinkButton>
        </SubmitContainer>
      </form>
    </>
  );
};

export default MFAToken;
